import React, { useEffect, useState } from 'react';
import CodeMirror, { EditorView } from "@uiw/react-codemirror";
import { css } from '@codemirror/lang-css';
import { javascript } from "@codemirror/lang-javascript";
import { html } from "@codemirror/lang-html";

const JavaScriptCodeEditor = ({ value, onChange }) => {
	const [isClient, setIsClient] = useState(false);

	useEffect(() => {
		setIsClient(true);
	}, []);

	if (!isClient) {
		return null; 
	}

	return (
		<CodeMirror
			value={value}
			height="200px"
			theme="light"
			extensions={[
                html(),
				css(),
                javascript({ jsx: true })
            ]}
			onChange={(value) => onChange(value)}
			basicSetup={{
				lineNumbers: true,
				closeBrackets: true,
				tabSize: 2,
				lintKeymap: true,
				bracketMatching: true,
				autocompletion: true,
				rectangularSelection: true,
				highlightActiveLine: true,
				highlightSelectionMatches: true,
				closeBracketsKeymap: true,
				searchKeymap: true,
			}}
		/>
	);
};

export default JavaScriptCodeEditor;